import Articles from './component';

export default Articles;
